import { render, staticRenderFns } from "./EBEmissionTable.vue?vue&type=template&id=16e5a53e&scoped=true"
import script from "./EBEmissionTable.vue?vue&type=script&lang=js"
export * from "./EBEmissionTable.vue?vue&type=script&lang=js"
import style0 from "./EBEmissionTable.vue?vue&type=style&index=0&id=16e5a53e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e5a53e",
  null
  
)

export default component.exports